var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseMangementTooltipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 11.906 11.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8512",
    "data-name": "Group 8512",
    transform: "translate(-273 -55.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M331.514,237.166a.514.514,0,0,1-.514-.514V233.91a.514.514,0,0,1,1.028,0v2.741a.514.514,0,0,1-.514.514Z",
    transform: "translate(-52.561 -173.207)",
    fill: "#3c3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M135.953,61.028a4.925,4.925,0,1,1-4.925,4.925,4.93,4.93,0,0,1,4.925-4.925m0-1.028a5.953,5.953,0,1,0,5.953,5.953A5.953,5.953,0,0,0,135.953,60Z",
    transform: "translate(143 -4.504)",
    fill: "#3c3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M327.952,164.611a.63.63,0,1,1-.63-.63.63.63,0,0,1,.63.63",
    transform: "translate(-48.369 -105.672)",
    fill: "#3c3838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseMangementTooltipIcon);
export default __webpack_public_path__ + "static/media/LicenseMangementTooltipIcon.cc0c99139cac0910ce2128d5211f0b4c.svg";
export { ForwardRef as ReactComponent };